module.exports = __webpack_public_path__ + "img/sparkle-5.39a9b40c.svg";